import { createFileRoute } from "@tanstack/react-router"
import { CompanyAppointmentsPage } from "@/features/companies/company-appointments-page"
export const Route = createFileRoute("/_authenticated/companies/$companyId/appointments/")({
    component: CompanyAppointmentsPage,
})
